// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","753":"component---src-pages-ir-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"d16d0aa289a8a33e13f5","753":"80612855eeba2c362f9f","883":"a19782f65da8089968fb"}[chunkId] + ".js";
};